import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { searchActions } from '../../store/searchStore';
import { domainActions } from '../../store/domainStore';
import { isObjectPathDefined } from '../../store/apiWrapper';
import { Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isNullOrUndefined } from '../../store/storeFunctions';
import FilterSelectTree from '../search/filterSelectTree';
import FilterSelect from '../search/filterSelect';
import FilterDateRange from '../search/filterDateRange';
import CrossIcon from '../../img/icons/Cross';

import './searchFilter.scss'

class SearchFilter extends React.Component {
    knownTypes = {
        'unknonw': () => (""),
        'select-tree': FilterSelectTree,
        'select': FilterSelect,
        'date-range': FilterDateRange
    };

    // default popup size is the default popup size set for multi select popup ('small')
    popupSizes = {
        'LegalFormID': 'large',
        'NutsID': 'medium',
        'NaceID': 'large'
    };

    state = {
        selection: {},
        collapse: [],
        collapseAll: false
    };

    componentDidMount() {
        this.syncFilterData();
    }

    componentDidUpdate() {
        this.syncFilterData();
    }

    render() {
        return (
            <article className="panel">
                <div className="panel-heading">
                    <div className='panel-heading-title'>
                        <div style={{marginRight:'auto', marginTop:'auto', marginBottom:'auto'}} ><Translate id="Search.Filter.Title" /></div>
                        <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{marginLeft: '.5em'}}/>
                    </div>
                </div>
                <div className="panel-block">
                    <div style={{fontSize:'.9em'}}>
                        {!this.props.search.searchFilterHasData && <Translate id="Search.Filter.NoData" />}
                        {this.props.search.searchFilterHasData && this.renderCollapseAll()}
                        {this.props.search.searchFilterHasData && this.props.search.searchResult.data.filters.map(f => this.renderFilter(f))}
                    </div>
                    {this.props.search.searchFilterHasData && this.renderApply()}
                </div>
            </article>
        );
    }

    renderFilter = (filter) => {
        const TagName = this.knownTypes[filter.TypeKey] || this.knownTypes["unknonw"];
        return (
            <div className='search-filter-box' key={filter.Key}>
                <div className='search-filter-title' onClick={() => this.toggle(filter.Key)}>
                    <span>
                        {filter.Name}
                    </span>
                    <FontAwesomeIcon className='svg-standard-color' icon={!this.state.collapse[filter.Key] ? "angle-up" : "angle-down"} />
                </div>
                <Collapse isOpen={!this.state.collapse[filter.Key]}>
                    <TagName filter={filter} popupSize={this.popupSizes[filter.Key]} />
                </Collapse>
            </div>
        );
    }

    renderApply = () => {
        return (
            <div className='search-filter-box-apply'>
                <button className={classnames('bb-button small gradient-1-gray', {'is-square': localStorage.locales_button_style === 'square'})} onClick={() => this.resetSearchFilterParams()}>
                    <Translate id="Search.Common.Reset" />
                </button>
                <button className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square'})} onClick={() => this.applyParams()}>
                    <Translate id="Search.FilterApply" />
                </button>
            </div>
        );
    }

    resetSearchFilterParams = () => {
        this.props.resetSearchFilters();
    }

    applyParams = () => {
        var filter = { ...this.props.search.searchParams };
        filter.extended = this.props.search.searchFilter;
        this.props.getSubjects(this.props.search.searchType, isNullOrUndefined(filter.extended) ? { ...this.props.search.searchParams } : filter);
    }

    renderCollapseAll = () => {
        return (
            <div className='search-filter-box-all'>
                <div className='search-filter-title' onClick={() => this.collapseAll()}>
                    <span>
                        <Translate id='Common.ShowHideAll' />
                    </span>
                    <FontAwesomeIcon className='svg-standard-color' icon={!this.state.collapseAll ? "angle-up" : "angle-down"} />
                </div>
            </div>
        );
    }

    syncFilterData = () => {
        if (isObjectPathDefined(this.props, 'search.searchResult.data.filters') && this.props.search.searchResult.data.filters.length > 0 &&
        this.props.domain.runtime === undefined) {
            let parsed = {};
            let sel = {};
            this.props.search.searchResult.data.filters.forEach(ch => {
                parsed[ch.Key] = { isRequesting: false, requestResult: this.mapTree(ch.Values || ch.values) };
                sel[ch.Key] = [];
            });
            this.setState({ selection: sel });
            this.props.attachRuntimeDomainData(parsed);
        }
    }
    mapTree = (values) => {
        if (isNullOrUndefined(values)) return null;
        return values.map(vv => ({ label: vv.name, normalized: vv.name, value: vv.id, expanded: (vv.children.length > 0), children: this.mapTree(vv.children) }))
    }

    toggle = (item) => {
        const newState = { ...this.state };
        newState.collapse[item] = !this.state.collapse[item];
        this.setState(newState);
    }

    collapseAll = () => {
        const newState = { ...this.state };
        newState.collapseAll = !newState.collapseAll;
        this.props.search.searchResult.data.filters.map(item =>
            newState.collapse[item.Key] = newState.collapseAll);
        this.setState(newState);
    }
}

export default connect(
    state => ({ search: state.search, domain: state.domain }),
    dispatch => bindActionCreators(Object.assign({}, searchActions, domainActions), dispatch),
)(SearchFilter);